import { bridge } from '../../../bridge';
import { getWebBaseURL } from '../../../getWebBaseURL';

export const moveToReviewList = (params: {
  goodsSno: number;
  beautyRecommendOptionsSno?: number;
  titleBar?: boolean;
}) => {
  const searchParams = new URLSearchParams();

  if (params.beautyRecommendOptionsSno) {
    searchParams.append(
      'beauty_recommend_option_sno',
      `${params.beautyRecommendOptionsSno}`,
    );
  }

  const path = `/goods/${params.goodsSno}/reviews/${searchParams}`;
  bridge.openDeeplink(
    `ably://webview?title_bar=${params.titleBar ?? false}&url=${path}`,
    {
      webCallback: async () => {
        const baseURL = await getWebBaseURL();
        location.href = `${baseURL}${path}`;
      },
    },
  );
};
